import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { useIsCreatable } from '../../hooks/objective/useIsCreatable';
import ObjectiveDialog from './Dialog';
import { useQueryClient } from 'react-query';
import { useFilterContext } from '../Filters/FilterProvider';

const CreatePanel = () => {
  const queryClient = useQueryClient();
  const [ objectiveCreatable ] = useIsCreatable();
  const [ open, setOpen ] = useState(false);
  const { t } = useTranslation();

  const {
    statusFilters,
    developmentStatusFilters,
    categoryFilters,
    dateRange
  } = useFilterContext();

  const useStyles = makeStyles({
    addBtn: {
      height: '40px'
    },
    buttonContainer: {
      height: '40px'
    }
  });

  const classes = useStyles();

  const onSubmitSuccess = () => {
    queryClient.invalidateQueries(
      [
        'objectives',
        statusFilters,
        developmentStatusFilters,
        categoryFilters,
        dateRange
      ]
    );
  };

  return (
    <>
      <Tooltip
        arrow
        title={ t('objective.button.create.tooltip') }
        disableFocusListener = { objectiveCreatable }
        disableHoverListener = { objectiveCreatable }
        disableTouchListener = { objectiveCreatable }
      >
        <span className={ classes.buttonContainer }>
          <Button
            variant="contained"
            color="primary"
            className={ classes.addBtn }
            onClick={ () => setOpen(!open) }
            disabled = { !objectiveCreatable }
          >
            <div>
              { t('objective.button.create.label') }
            </div>
          </Button>
        </span>
      </Tooltip>
      <ObjectiveDialog
        open={ open }
        handleClose={ () => setOpen(false) }
        onSubmitSuccess={ onSubmitSuccess }
      />
    </>
  );
};

export default CreatePanel;
